import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import { tailwindConfig } from '../../utils/tailwind.esm.js';

var theme = tailwindConfig.theme;
var themes = {
  light: {
    plain: {
      color: theme.textColor.gray['600'],
      backgroundColor: theme.backgroundColor.white
    },
    styles: [{
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: theme.textColor.gray['400'],
        fontStyle: 'italic'
      }
    }, {
      types: ['namespace'],
      style: {
        opacity: 0.7
      }
    }, {
      types: ['string', 'attr-value'],
      style: {
        color: theme.textColor.green['500']
      }
    }, {
      types: ['punctuation', 'operator'],
      style: {
        color: theme.textColor.gray['400']
      }
    }, {
      types: ['property'],
      style: {
        color: theme.textColor.gray['600']
      }
    }, {
      types: ['entity', 'url', 'symbol', 'number', 'boolean', 'variable', 'constant', 'regex', 'inserted', 'unit'],
      style: {
        color: theme.textColor.orange['500']
      }
    }, {
      types: ['atrule', 'attr-name', 'selector'],
      style: {
        color: theme.textColor.green['500']
      }
    }, {
      types: ['function', 'deleted', 'tag'],
      style: {
        color: theme.textColor.blue['500']
      }
    }, {
      types: ['tag', 'selector', 'keyword'],
      style: {
        color: theme.textColor.red['500']
      }
    }]
  },
  dark: {
    plain: {
      color: tailwindConfig.theme.textColor.gray['200'],
      backgroundColor: tailwindConfig.theme.backgroundColor.gray['900']
    },
    styles: [{
      types: ['comment'],
      style: {
        color: '#6b7281',
        fontStyle: 'italic'
      }
    }, {
      types: ['string', 'attr-value'],
      style: {
        color: 'rgb(180, 216, 128)'
      }
    }, {
      types: ['class-name', 'maybe-class-name'],
      style: {
        color: 'rgb(255, 204, 99)'
      }
    }, {
      types: ['keyword', 'attr-name', 'token'],
      style: {
        color: 'rgb(200, 143, 236)'
      }
    }, {
      types: ['punctuation'],
      style: {
        color: 'rgb(134, 221, 255)'
      }
    }, {
      types: ['variable'],
      style: {
        color: 'rgb(143, 147, 162)'
      }
    }, {
      types: ['constant'],
      style: {
        color: 'rgb(255, 203, 107)'
      }
    }, {
      types: ['number', 'char'],
      style: {
        color: 'rgb(247, 140, 108)'
      }
    }, {
      types: ['tag', 'deleted', 'builtin'],
      style: {
        color: 'rgb(143, 147, 163)'
      }
    }, {
      types: ['function'],
      style: {
        color: 'rgb(128, 168, 255)'
      }
    }, {
      types: ['symbol', 'inserted'],
      style: {
        color: 'rgb(195, 232, 141)'
      }
    }]
  }
};

export default themes;
//# sourceMappingURL=theme.esm.js.map
